import { useContext } from 'react'

import { FeatureAvailabilityContext } from '@contexts/features'

const useFeatures = () => useContext(FeatureAvailabilityContext)

export default {
  useFeatures,
}
